import icon1 from '../../../Assets/Icons/prototype2.svg';
import icon2 from '../../../Assets/Icons/prototype1.svg';
import icon3 from '../../../Assets/Icons/prototype3.svg';
export const prototype = [
    {
        icon:icon2,
        title:"Gestures",
        color:"#F1EBFF",
        desc:"Add gestures such as double taps and swipes to demonstrate real-life user interactions "
    },
    {
        icon:icon1,
        title:"Transitions",
        desc:"Add screen transitions such as slide right, slide down, fade ...",
        color:"#ec63231a"
    },
    {
        icon:icon3,
        title:"Hotspots",
        desc:"Create hotspots over image and link them where you want.",
        color:"#ff4f5b31"
    },
]